import HttpService from './HttpService';

const BulksApi = HttpService('/api/bulks/');
const doPost = (action, data) => BulksApi.post(action, data);
const doGet = (url) => BulksApi.get(url);
const doDelete = (url) => BulksApi.delete(url);

export default {
  getBulkTypes() {
    const apiAction = 'GetBulkTypes';
    return doGet(apiAction);
  },
  getBulks(activeSiteId) {
    const apiAction = 'GetBulks';
    const queryString = `activeSiteId=${activeSiteId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createBulk(bulk) {
    const apiAction = 'CreateBulk';
    return doPost(apiAction, bulk);
  },
  updateBulk(bulkUpdate) {
    const apiAction = 'UpdateBulk';
    return doPost(apiAction, bulkUpdate);
  },
  deleteBulk(id) {
    const apiAction = 'DeleteBulk';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
};
